<ng-container>
  <section class="text--small text--gray spacing--padding-top">{{ 'cart-overview.total-amount.title' | translate }}</section>
  <div class="price-container">
    <span class="spinner-container" *ngIf="showPriceSpinner$ | async">
      <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
      <span class="spinner-text blink-soft">{{ 'cart-overview.total-amount.priceSpinnerText' | translate }}</span>
    </span>
    <span *ngIf="hasCalculatedAllPrices$ | async" class="text--large total-price">{{ totalPrice$ | async | agrCurrency: (currency$ | async) }}</span>
  </div>
</ng-container>
